module.exports = __webpack_public_path__ + "media/staff/pharon-86fd5f8c.png";